import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=7c48029e&scoped=true&"
import script from "./Documents.vue?vue&type=script&lang=js&"
export * from "./Documents.vue?vue&type=script&lang=js&"
import style0 from "./Documents.vue?vue&type=style&index=0&id=7c48029e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c48029e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseRichtext: require('/app/components/base/Richtext.vue').default})
